// @ts-nocheck
/* eslint-disable */
let loadProm = null;

export function loadClamp() {
	if (!loadProm) {
		loadProm = Mapy.Util.loadScript(`/js/clamp.min.js`);
	}

	return loadProm;
}
